import * as yup from 'yup';

/** CMS fallback when Sitecore `requiredMessage` is empty. */
export const DEFAULT_REQUIRED_RADIO_MESSAGE = 'Maak een keuze uit bovenstaande opties.';

/** Prefer the CMS copy; never validate with an empty/undefined message. */
export const requiredChoiceMessage = (message?: string | null): string => {
  const trimmed = message?.trim();
  return trimmed || DEFAULT_REQUIRED_RADIO_MESSAGE;
};

/** Yup string rule for a required radio choice (empty / missing → error). */
export const requiredRadioChoice = (message?: string | null) =>
  yup.string().required(requiredChoiceMessage(message));
